export default "__VITE_ASSET__6e61e08a__"